if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class GltheaaQuickAddModal extends ModalDialog {
      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
    }
  );
}

if (!customElements.get('gltheaa-quick-add')) {
  customElements.define(
    'gltheaa-quick-add',
    class GltheaaQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const variantsScript = this.querySelector('[data-quick-add-variants]');
        this.variants = [];
        try {
          this.variants = JSON.parse(variantsScript?.textContent || '[]');
        } catch (error) {
          console.error(error);
        }

        this.productForm = this.querySelector('product-form');
        this.variantInput = this.querySelector('.product-variant-id');
        this.image = this.querySelector('.gltheaa-quick-add__image');
        this.compareEl = this.querySelector('[data-quick-add-compare]');
        this.currentEl = this.querySelector('[data-quick-add-current]');
        this.variantSelects = this.querySelector('variant-selects');

        this.variantSelects?.addEventListener('change', () => this.updateVariant());
        this.updateVariant();
      }

      getSelectedOptions() {
        return Array.from(this.querySelectorAll('fieldset input:checked')).map((input) => input.value);
      }

      findVariant(selected) {
        return this.variants.find((variant) =>
          variant.options.every((option, index) => option === selected[index])
        );
      }

      updateOptionAvailability(selected) {
        this.querySelectorAll('fieldset').forEach((fieldset, optionIndex) => {
          const isSwatch = fieldset.classList.contains('gltheaa-product__option--swatch');

          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const isAvailable = this.variants.some((variant) => {
              if (!variant.available || variant.options[optionIndex] !== input.value) return false;
              return variant.options.every((option, index) => index === optionIndex || option === selected[index]);
            });

            input.classList.toggle(isSwatch ? 'visually-disabled' : 'disabled', !isAvailable);
          });
        });
      }

      updateVariant() {
        const selected = this.getSelectedOptions();
        const variant = selected.length ? this.findVariant(selected) : this.variants[0];

        this.updateOptionAvailability(selected);
        this.updatePrice(variant);
        this.updateImage(variant);
        this.updateForm(variant);
      }

      updatePrice(variant) {
        if (!this.currentEl) return;

        if (!variant) {
          this.currentEl.textContent = '';
          this.compareEl?.classList.add('hidden');
          return;
        }

        this.currentEl.textContent = variant.price;

        if (this.compareEl) {
          if (variant.compare_at_price) {
            this.compareEl.textContent = variant.compare_at_price;
            this.compareEl.classList.remove('hidden');
          } else {
            this.compareEl.textContent = '';
            this.compareEl.classList.add('hidden');
          }
        }
      }

      updateImage(variant) {
        if (!this.image || !variant?.image) return;

        this.image.src = variant.image.src;
        this.image.srcset = variant.image.srcset;
        if (variant.image.alt) this.image.alt = variant.image.alt;
      }

      updateForm(variant) {
        if (!this.variantInput || !this.productForm) return;

        if (variant?.id) {
          this.variantInput.value = variant.id;
          this.variantInput.disabled = !variant.available;
        } else {
          this.variantInput.value = '';
          this.variantInput.disabled = true;
        }

        if (!variant) {
          this.productForm.toggleSubmitButton(true, window.variantStrings.unavailable);
          return;
        }

        if (!variant.available) {
          this.productForm.toggleSubmitButton(true, window.variantStrings.soldOut);
          return;
        }

        this.productForm.toggleSubmitButton(false);
      }
    }
  );
}
